import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Formik, FormikValues } from 'formik';
import * as Yup from 'yup';

import createSchool from '../../../lib/apiClient/schools/create';
import { selectCities } from '../../../redux/reducers/CitiesReducer';
import { selectSchoolTypes } from '../../../redux/reducers/SchoolTypesReducer';

import FormikInputField from '../../common/ui/FormikInputField/Input';
import PopupForm from '../../common/ui/PopupForm/Form';
import PopupFormHeader from '../../common/ui/PopupForm/Header';
import PopupFormErrorMessage from '../../common/ui/PopupForm/ErrorMessage';
import Button from '../../common/ui/Button/Button';
import Search from '../../common/ui/Search/Search';

interface Props {
  onClose(): void;
}

const CreateSchoolForm = ({ onClose }: Props) => {
  const [error, setError] = useState<string | null>(null);

  const cities = Object.values(useSelector(selectCities));
  const citiesNames = cities.map(({ name }) => name);

  const types = Object.values(useSelector(selectSchoolTypes));
  const typesNames = types.map(({ name }) => name);

  const initialValues = { name: '', code: '', city: '', type: '' };

  const validationSchema = Yup.object({
    name: Yup.string()
      .max(255, 'Максимальная длина - 255 символов')
      .required('Обязательное поле'),
    code: Yup.string()
      .max(255, 'Максимальная длина - 255 символов')
      .required('Обязательное поле'),
    city: Yup.string()
      .oneOf(citiesNames, 'Указанного города не существует')
      .required('Обязательное поле'),
    type: Yup.string()
      .oneOf(typesNames, 'Указанного типа ОО не существует')
      .required('Обязательное поле'),
  });

  const submit = async ({ name, code, city, type }: FormikValues) => {
    try {
      const cityId = cities.find(({ name: cityName }) => cityName === city)
        ?.id!;

      const typeId = types.find(({ name: typeName }) => typeName === type)
        ?.id!;

      await createSchool({ name, code, cityId, typeId });
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={submit}
    >
      <PopupForm close={onClose} closable>
        <PopupFormHeader>
          Добавление школы
          <PopupFormErrorMessage text={error ?? ''} visible={error !== null} />
        </PopupFormHeader>

        <FormikInputField
          name="name"
          placeholder="Название"
          onFocus={() => setError(null)}
        />

        <Search
          name="type"
          placeholder="Тип ОО"
          options={typesNames}
          onFocus={() => setError(null)}
        />

        <FormikInputField
          name="code"
          placeholder="Код"
          onFocus={() => setError(null)}
        />

        <Search
          name="city"
          placeholder="Город"
          options={citiesNames}
          onFocus={() => setError(null)}
        />

        <Button type="submit">Подтвердить</Button>
      </PopupForm>
    </Formik>
  );
};

export default CreateSchoolForm;
